import { useId, useState } from 'react'

export function useHourlyInputCellFaultDisclosure() {
  const descriptionId = useId()
  const [anchorElement, setAnchorElement] = useState<HTMLTableCellElement | null>(null)
  const [isHovered, setIsHovered] = useState(false)
  const [isFocused, setIsFocused] = useState(false)

  return {
    descriptionId,
    anchorElement,
    registerAnchor: setAnchorElement,
    isOpen: isHovered || isFocused,
    handleCellMouseEnter: () => setIsHovered(true),
    handleCellMouseLeave: () => setIsHovered(false),
    handleFieldFocus: () => setIsFocused(true),
    handleFieldBlur: () => setIsFocused(false),
  }
}
